<div class="condensed-full-header-wrapper">
  <div>
    <div class="detailview-image">
      @if (currentView().templateId != null) {
        <div
          class="image-border"
          miq-bg-image
        [secureImage]="
          reportRecordData()
            | reportFieldFormatter
              : { templateId: currentView().templateId, field: imageField, joinString: true, onlyUrl: false }
            | async
        "
        ></div>
      }
    </div>
    @if (additionalImageField) {
      <div>
        @if (!hasAdditionalImage) {
          <div class="additional-image-section">
            <button class="additional-image-btn" (click)="addAdditionalImage('add')">
              <mat-icon svgIcon="add-icon"></mat-icon>
              <span>{{ 'template.additionalImage' | translate }}</span>
            </button>
          </div>
        } @else {
          <div class="detailview-image additional_image">
            <div class="actions">
              <mat-icon svgIcon="edit-icon" (click)="addAdditionalImage('edit')"></mat-icon>
              <mat-icon svgIcon="delete" (click)="deleteAdditionalImage()"></mat-icon>
            </div>
            <div
              class="image-border"
              miq-bg-image
            [secureImage]="
              reportRecordData()
                | reportFieldFormatter
                  : {
                      templateId: currentView().templateId,
                      field: additionalImageField,
                      joinString: true,
                      onlyUrl: false,
                    }
                | async
            "
          ></div>
        </div>
      }
    </div>
  }
</div>
</div>
